// src/pages/user/User.tsx
import classes from './User.module.sass'
import { SectionList } from './components/sectionList/SectionList'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../../store/slices/currentUserSlice'
import { useCopyToClipboard } from '../../common/hooks/useCopyToClipboard'
import QRCode from 'react-qr-code'
import { useUser } from './hooks/useUser'
import { ExecutorClusters } from './components/executorClusters/ExecutorClusters'
import { Modal } from '../../common/components/modal/Modal'
import { Stats } from './components/executorClusters/components/stats/Stats'
import { Details } from './components/executorClusters/components/details/Details'
import { Button } from '../../common/components/button/Button'
import { Settings } from './components/executorClusters/components/settings/Settings'

export const User = () => {
  const currentUser = useSelector(selectCurrentUser)
  const { copied, copy } = useCopyToClipboard()
  const {
    clusters,
    loading,
    statsModalActive,
    detailsModalActive,
    selectedCluster,
    handleStatsClick,
    handleDetailsClick,
    handleGoTo,
    closeStatsModal,
    closeDetailsModal,
    goToTasks,
    handleSettingsClick,
    settingsModalActive,
    closeSettingsModal,
    settings,
  } = useUser()

  const isExecutor = clusters.length > 0
  const isAdmin = (currentUser?.user_clusters?.length ?? 0) > 0

  const headerTitle = isAdmin
    ? 'Кабинет администратора'
    : isExecutor
      ? 'Кабинет исполнителя'
      : 'Кабинет пользователя'

  return (
    <div className={classes.Container}>
      <Helmet>
        <title>{headerTitle}</title>
        <meta name="description" content={headerTitle} />
      </Helmet>

      <div className={classes.Header}>{headerTitle}</div>

      {!loading && clusters.length > 0 && (
        <ExecutorClusters
          clusters={clusters}
          onStatsClick={handleStatsClick}
          onDetailsClick={handleDetailsClick}
          onGoTo={handleGoTo}
          onSettingsClick={handleSettingsClick}
        />
      )}

      {!loading && isExecutor && (
        <div className={classes.ExecutorButtons}>
          <Button text="Задания" onClick={goToTasks} />
        </div>
      )}

      <SectionList />

      <div className={classes.InfoBlock}>
        {currentUser?.email && (
          <div className={classes.Id}>
            <div className={classes.Label}>Email</div>
            {currentUser.email}
          </div>
        )}

        {currentUser && (
          <div
            className={classes.Id}
            onClick={() => copy(currentUser.uuid ? currentUser.uuid : String(currentUser.id))}
          >
            <div className={classes.Label}>Ваш id</div>
            {currentUser.uuid ? currentUser.uuid : currentUser.id}
            {copied && <div className={classes.Copied}>СКОПИРОВАНО</div>}
          </div>
        )}
      </div>

      {currentUser?.uuid && <QRCode value={currentUser?.uuid} className={classes.Qr} />}

      <Modal modalActive={statsModalActive} setModalActive={closeStatsModal}>
        <Stats cluster={selectedCluster} />
      </Modal>

      <Modal modalActive={detailsModalActive} setModalActive={closeDetailsModal}>
        <Details cluster={selectedCluster} />
      </Modal>
      <Modal modalActive={settingsModalActive} setModalActive={closeSettingsModal}>
        <Settings cluster={selectedCluster} settings={settings} />
      </Modal>
    </div>
  )
}
